import { CalendarClock } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { EconomicCalendar } from "@/components/EconomicCalendar";
import { ConnectGate } from "@/components/ConnectGate";
import { useLang } from "@/context/LanguageContext";

export default function Calendrier() {
  const { t } = useLang();
  return (
    <div>
      <PageHeader title={t("page.calTitle")} subtitle={t("page.calSub")} icon={CalendarClock} />
      <ConnectGate>
        <div className="rounded-lg border border-[#222733] bg-[#11141A] p-4 sm:p-5">
          <EconomicCalendar />
        </div>
      </ConnectGate>
    </div>
  );
}
